import { Injectable } from '@angular/core';
import { QueryEntity, combineQueries } from '@datorama/akita';
import { MemberCardStore, MemberCardState } from './member-card.store';
import { BalanceQuery } from '../balance/balance.query';
import { map, switchMap } from 'rxjs/operators';
import { MemberQuery } from '../member/member.query';
import { Observable } from 'rxjs';
import { MemberCard } from './member-card.model';

@Injectable({ providedIn: 'root' })
export class MemberCardQuery extends QueryEntity<MemberCardState> {
  constructor(protected store: MemberCardStore, private balanceQuery: BalanceQuery, private memberQuery: MemberQuery) {
    super(store);
  }
  selectCurrentCard() {
    return this.selectEntity(this.memberQuery.getUserContext().memberId);
  }

  getCurrentCard(){
    return this.getEntity(this.memberQuery.getUserContext().memberId);
  }

  selectObservedMemberCard() {
    return this.memberQuery
      .select((state) => (state.user ? state.user.memberId : 0))
      .pipe(switchMap((id) => this.selectEntity(id)));
  }

  selectUserInProductCodes(productCodes: string[]): Observable<boolean> {
    return this.selectCurrentCard().pipe(
      map((cc) => {
        if (cc) {
          return productCodes.includes(cc.ProductCode) || productCodes.includes(cc.ProductCodeDisplayName);
        } else {
          return false;
        }
      })
    );
  }

  selectCardWithBalance(purse: number, memberId: string = ''): Observable<MemberCard | undefined> {
    memberId = memberId || this.memberQuery.getUserContext().memberId;
    return combineQueries([this.selectEntity(memberId), this.balanceQuery.selectPurse(purse, memberId)]).pipe(
      map(([memberCard, balance]) => {
        if (memberCard && balance) {
          return { ...memberCard, AvailableBalance: balance };
        } else {
          return undefined;
        }
      })
    );
  }

  selectCardsWithBalance(purse: number): Observable<MemberCard[]> {
    return combineQueries([this.selectAll(), this.balanceQuery.selectBalancesByPurse(purse)]).pipe(
      map(([memberCards, balances]) => {
        return memberCards.map((memberCard) => {
          let balance = balances.find((b) => b.memberId === memberCard.MemberId);
          return {
            ...memberCard,
            AvailableBalance: balance ? balance.balance : 0,
          };
        });
      })
    );
  }
}
